import { PanelStore } from '../interfaces';

export const UserManagementSelectors = {
  getLoading: (state: PanelStore.RootState) => state.userManagement.loading,
  getError: (state: PanelStore.RootState) => state.userManagement.error,
  getErrorInfo: (state: PanelStore.RootState) => state.userManagement.errorInfo,
  getAllMerchantUsers: (state: PanelStore.RootState) => state.userManagement.allMerchantUsers,
  getDeleteSuccess: (state: PanelStore.RootState) => state.userManagement.deleteSuccess,
  getSwapOwnerSuccess: (state: PanelStore.RootState) => state.userManagement.swapOwnerSuccess,
  getInviteLoading: (state: PanelStore.RootState) => state.userManagement.inviteLoading,
  getInviteError: (state: PanelStore.RootState) => state.userManagement.inviteError,
  getInviteErrorInfo: (state: PanelStore.RootState) => state.userManagement.inviteErrorInfo,
};
